import React, { useMemo } from 'react';
import { RSButtonLink } from '../../../reservation-page/RSButtonLink';
import KantanIcon from '../../../reservation-page/icons/kantan-icon.svg';
import { useUserMe } from '../../../hooks/api/me';
import { RSKantanIconButtonAnchor } from '../../../reservation-page/RSKantanIconButtonAnchor';
import { RSButtonAnchor } from 'src/reservation-page/RSButtonAnchor';
import {
  EventSchemeResource,
  CourseSchemeResource,
} from 'src/interfaces/reservation_flow';
import { useIntl } from 'react-intl';

type Props = {
  merchant_public_id: string;
  resource_public_id: string;
  contactUrl?: string;
  resource: EventSchemeResource | CourseSchemeResource | undefined;
  newReservationFlowPath: string;
};

const MerchantStickyFooter = ({
  merchant_public_id,
  resource_public_id,
  contactUrl,
  resource,
  newReservationFlowPath,
}: Props) => {
  const { user } = useUserMe();
  const intl = useIntl();

  const ButtonContent = useMemo(() => {
    if (resource && !resource.is_reservable)
      return (
        <RSButtonAnchor
          isBlock={true}
          variant="outline"
          href={
            contactUrl ||
            `/${merchant_public_id}/contact?via=${resource_public_id}`
          }
        >
          {intl.formatMessage({
            id: 'merchants.bookingPages.inquiry',
          })}
        </RSButtonAnchor>
      );
    // 組織管理者・スタッフアクセスの場合はresourceが存在しないので、予約ボタンのみ表示する
    if (
      !resource ||
      (user && resource.acceptable_customer_login_status !== 'guest')
    ) {
      return (
        <RSButtonLink isBlock={true} href={newReservationFlowPath}>
          {intl.formatMessage({
            id: 'merchants.bookingPages.bookReservation',
          })}
        </RSButtonLink>
      );
    }
    return (
      <div className="flex flex-col gap-1.5">
        {resource.acceptable_customer_login_status === 'all' && (
          <RSButtonLink isBlock={true} href={newReservationFlowPath}>
            {intl.formatMessage({
              id: 'merchants.bookingPages.bookGuestReservation',
            })}
          </RSButtonLink>
        )}
        {resource.acceptable_customer_login_status === 'guest' && (
          <RSButtonLink isBlock={true} href={newReservationFlowPath}>
            {intl.formatMessage({
              id: 'merchants.bookingPages.bookReservation',
            })}
          </RSButtonLink>
        )}
        {resource.acceptable_customer_login_status !== 'guest' && (
          <RSKantanIconButtonAnchor
            icon={<KantanIcon width="24" height="24" viewBox="0 0 24 24" />}
            isBlock={true}
            href={`/signin/user?return_to=${newReservationFlowPath}`}
            variant="black"
          >
            {intl.formatMessage({
              id: 'merchants.bookingPages.bookReservationWithReservation',
            })}
          </RSKantanIconButtonAnchor>
        )}
      </div>
    );
  }, [
    contactUrl,
    intl,
    merchant_public_id,
    newReservationFlowPath,
    resource,
    resource_public_id,
    user,
  ]);

  return (
    <div className="z-2 legacyPc:hidden sticky  bottom-0 block border-0 border-t border-solid border-gray-50 bg-white px-[20px] py-2">
      {ButtonContent}
    </div>
  );
};

export default MerchantStickyFooter;
